import { Component } from '@angular/core';

@Component({
  selector: 'app-privacy-statement-link',
  templateUrl: './privacy-statement-link.component.html',
  styleUrls: ['./privacy-statement-link.component.scss'],
  standalone: false
})
export class PrivacyStatementLinkComponent {}
